import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateEncodeURL } from "../../reducer/loginReducer";

const useLogoEncoding = () => {
  const dispatch = useDispatch();
  const { hotelDetails } = useSelector((store) => store.login);

  useEffect(() => {
    const fetchImage = async () => {
      if (hotelDetails?.logo) {
        try {
          const base64Image = await getImageAsBase64(hotelDetails?.logo);

          dispatch(updateEncodeURL(base64Image));
        } catch (err) {
          dispatch(updateEncodeURL(hotelDetails?.logo));
        }
      }
    };

    fetchImage(); // Call the async function
  }, [hotelDetails?.id, hotelDetails?.logo]);

  const getImageAsBase64 = async (url) => {
    let response = "";
    try {
      response = await fetch(url, {
        method: "GET",
        headers: {
          "Cache-Control": "no-cache",
        },
      });
    } catch (err) {}

    const blob = await response.blob();
    const reader = new FileReader();

    return new Promise((resolve) => {
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };
};

export default useLogoEncoding;
